module.exports = __webpack_public_path__ + "static/media/Banner membresía golden.b92b920d.svg";